import { Routes } from '@angular/router';
import { NotificationsComponent } from './common/utility-management/notifications/components/notifications.component';
import { AuthGuard } from './trash/shared/guard/auth.guard';
import { BaseComponent } from './views/layout/base/base.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { HomepageComponent } from './homepage/homepage.component';
import { CompanyManagementCollections } from './company-management/common';
import { StatusMappingManagementCollections } from './configurations/status-mapping-management/common/collections';
export const routes: Routes = [
  {
    path: '',
    component: BaseComponent,
    children: [
      {
        path: '',
        component: HomepageComponent,
        pathMatch: 'full'
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        data: { title: 'GENERAL.NOTIFICATIONS' },
        canActivate: [AuthGuard]
      },
      // User Management - System
      {
        path: 'user-management/users',
        loadComponent: () =>
          import('./common/user-management/system-management/users/components/users-list/users-list.component').then(
            (m) => m.UsersListComponent
          ),
        data: { title: 'BREADCRUMBS.SYSTEM_MANAGEMENT_USERS' },
        canActivate: [AuthGuard]
      },
      {
        path: 'user-management/scopes',
        loadComponent: () =>
          import('./common/user-management/system-management/scopes/components/scopes-list/scopes-list.component').then(
            (m) => m.ScopesListComponent
          ),
        data: { title: 'BREADCRUMBS.SYSTEM_MANAGEMENT_SCOPES' },
        canActivate: [AuthGuard]
      },
      {
        path: 'user-management/accounts',
        loadComponent: () =>
          import(
            './common/user-management/system-management/accounts/components/accounts-list/accounts-list.component'
          ).then((m) => m.AccountsListComponent),
        data: { title: 'BREADCRUMBS.SYSTEM_MANAGEMENT_ACCOUNTS' },
        canActivate: [AuthGuard]
      },
      // User Management - Accounts
      {
        path: 'account-management/accounts/:accounted/users',
        loadComponent: () =>
          import(
            './common/user-management/account-management/users/components/account-user-list/account-user-list.component'
          ).then((m) => m.AccountUserListComponent),
        data: { title: 'BREADCRUMBS.ACCOUNTS_MANAGEMENT_USERS' },
        canActivate: [AuthGuard]
      },
      {
        path: 'account-management/accounts/:accounted/specialized-roles',
        loadComponent: () =>
          import(
            './common/user-management/account-management/specialized-roles/components/specialized-roles-list/specialized-roles-list.component'
          ).then((m) => m.SpecializedRolesListComponent),
        data: { title: 'BREADCRUMBS.ACCOUNTS_MANAGEMENT_SPECIALIZED_ROLES' },
        canActivate: [AuthGuard]
      },
      // Account Management - Staff Accounts
      {
        path: 'account-management/accounts/:accounted/staff-accounts',
        loadComponent: () =>
          import(
            '../app/account-management/staff-accounts/components/staff-accounts-list/staff-accounts-list.component'
          ).then((m) => m.StaffAccountsListComponent),
        data: { title: 'BREADCRUMBS.ACCOUNTS_MANAGEMENT_STAFF_ACCOUNTS' },
        canActivate: [AuthGuard]
      },
      // Account Management - Roles
      {
        path: 'account-management/accounts/:accounted/roles',
        loadComponent: () =>
          import('./account-management/roles/components/roles-list/roles-list.component').then(
            (m) => m.RolesListComponent
          ),
        data: { title: 'GENERAL.ROLES' },
        canActivate: [AuthGuard]
      },

      // Companies
      {
        path: CompanyManagementCollections.Companies,
        data: { title: 'MENUS.COMPANIES' },
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./company-management/components/companies-list/companies-list.component').then(
                (m) => m.CompaniesListComponent
              ),
            data: { title: null },
            canActivate: [AuthGuard]
          }
        ]
      },
      // Status Mapping
      {
        path: 'configurations/status-mapping',
        data: { title: 'MENUS.STATUS_MAPPING' },
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './configurations/status-mapping-management/components/status-mapping-list/status-mapping-list.component'
              ).then((m) => m.StatusMappingListComponent),
            data: { title: null },
            canActivate: [AuthGuard]
          }
        ]
      },
      // Delivery Instruction Management
      {
        path: 'delivery/instructions',
        data: { title: 'MENUS.DELIVERY_INSTRUCTIONS' },
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './delivery-instruction-management/components/delivery-instructions-list/delivery-instructions-list.component'
              ).then((m) => m.DeliveryInstructionsListComponent),
            data: { title: null },
            canActivate: [AuthGuard]
          }
        ]
      },
      // National Address Finder
      {
        path: 'national-address-finder',
        loadComponent: () =>
          import('./national-address-finder/components/national-address-finder/national-address-finder.component').then(
            (m) => m.NationalAddressFinderComponent
          ),
        data: { title: 'MENUS.NATIONAL_ADDRESS_FINDER' },
        canActivate: [AuthGuard]
      },
      // Workflow Management
      {
        path: 'workflows',
        data: { title: 'MENUS.WORKFLOW' },
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./workflows/components/workflows-list/workflows-list.component').then(
                (m) => m.WorkflowsListComponent
              ),
            data: { title: null },
            canActivate: [AuthGuard]
          },
          {
            path: 'create',
            data: {
              title: 'WORKFLOW.CREATE_WORKFLOW'
            },
            canActivate: [AuthGuard],
            children: [
              {
                path: '',
                data: {
                  title: null
                },
                loadComponent: () =>
                  import(
                    './workflows/components/upsert-workflow/upsert-workflow.component'
                  ).then((m) => m.UpsertWorkflowComponent),
                canActivate: [AuthGuard]
              }
            ]
          },
          {
            path: 'edit/:id',
            data: {
              title: 'WORKFLOW.EDIT_WORKFLOW'
            },
            canActivate: [AuthGuard],
            children: [
              {
                path: '',
                data: {
                  title: null
                },
                loadComponent: () =>
                  import(
                    './workflows/components/upsert-workflow/upsert-workflow.component'
                  ).then((m) => m.UpsertWorkflowComponent),
                canActivate: [AuthGuard]
              }
            ]
          }
        ]
      },
      // Location Management
      {
        path: 'area-lookups/countries',
        loadComponent: () =>
          import('./common/core/location-management/countries/components/countries.component').then(
            (m) => m.CountriesComponent
          ),
        data: { title: 'BREADCRUMBS.LOCATION_MANAGEMENT_COUNTRIES' },
        canActivate: [AuthGuard],
        children: []
      },
      {
        path: 'area-lookups/countries',
        data: { title: 'BREADCRUMBS.LOCATION_MANAGEMENT_COUNTRIES' },
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./common/core/location-management/countries/components/countries.component').then(
                (m) => m.CountriesComponent
              ),
            data: { title: null },
            canActivate: [AuthGuard]
          }
        ]
      },
      {
        path: 'area-lookups/states',
        loadComponent: () =>
          import('./common/core/location-management/states/components/states.component').then((m) => m.StatesComponent),
        data: { title: 'BREADCRUMBS.LOCATION_MANAGEMENT_STATES' },
        canActivate: [AuthGuard]
      },
      {
        path: 'area-lookups/cities',
        loadComponent: () =>
          import('./common/core/location-management/cities/components/cities.component').then((m) => m.CitiesComponent),
        data: { title: 'BREADCRUMBS.LOCATION_MANAGEMENT_CITIES' },
        canActivate: [AuthGuard]
      },
      {
        path: 'area-lookups/districts',
        loadComponent: () =>
          import('./common/core/location-management/districts/components/districts.component').then(
            (m) => m.DistrictsComponent
          ),
        data: { title: 'BREADCRUMBS.LOCATION_MANAGEMENT_DISTRICTS' },
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'auth',
    loadChildren: () => import('./views/pages/auth/auth/auth.module').then((m) => m.AuthModule),
    data: { title: 'GENERAL.AUTH' }
  },
  {
    path: '**',
    component: ErrorPageComponent,
    title: 'GENERAL.NOT_FOUND_PAGE'
  }
];
